import React, { useContext, useState, useEffect } from "react";
import { Text, NewAddressForm, MobileContext } from "components/common";
import { colors } from "theme";
import { useMutation } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

const Address = ({
  user,
  setSuccess,
  resetSuccess,
  setError,
  SettingsInputContainer,
  SettingsButton,
  next
}) => {
  const {
    street: bStreet = "",
    city: bCity = "",
    state: bState = "",
    zip: bZip = "",
    unitNumber: bUnit = ""
  } = user.billing_address || {};
  const {
    street: sStreet = "",
    city: sCity = "",
    state: sState = "",
    zip: sZip = "",
    unitNumber: sUnit = ""
  } = user.shipping_address || {};
  const bAddress = `${bStreet}, ${bCity} ${bState} ${bZip} ${bUnit}`;
  const sAddress = `${sStreet}, ${sCity} ${sState} ${sZip} ${sUnit}`;
  const [sameAddress, setSameAddress] = useState(bAddress === sAddress || !Object.keys(user.shipping_address || {}).length);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [supportalUpdateAddress] = useMutation(SUPPORTAL_UPDATE_ADDRESS);
  const [shouldValidate, setShouldValidate] = useState(false);
  const [shippingValid, setShippingValid] = useState(false);
  const [billingValid, setBillingValid] = useState(false);
  const { isMobile } = useContext(MobileContext);

  useEffect(() => {
    if (shouldValidate) {
      setShouldValidate(false);
    }
  }, [shouldValidate]);

  useEffect(() => {
    if (shippingValid && billingValid) {
      if (isMobile) next();
    }
  }, [shippingValid, billingValid]); //eslint-disable-line

  const toggleShipAddress = () => {
    setSameAddress(!sameAddress);
  };

  const renderShippingAddress = () => (
    <NewAddressForm
      address={sStreet}
      city={sCity}
      state={sState}
      zip={sZip}
      unitNumber={sUnit}
      style={{ maxWidth: "400px" }}
      type="shipping"
      loading={loading}
      setLoading={setLoading}
      shouldValidate={shouldValidate}
      addressValid={setShippingValid}
      save={save}
      resetSuccess={resetSuccess}
      SettingsInputContainer={SettingsInputContainer}
    />
  );

  const renderBillingAddress = () => (
    <NewAddressForm
      address={bStreet}
      city={bCity}
      state={bState}
      zip={bZip}
      unitNumber={bUnit}
      style={{ maxWidth: "400px" }}
      type="billing"
      loading={loading}
      setLoading={setLoading}
      shouldValidate={shouldValidate}
      addressValid={setBillingValid}
      resetSuccess={resetSuccess}
      save={save}
      SettingsInputContainer={SettingsInputContainer}
    />
  );

  const save = ({ address, type }) => {
    if (!isMobile) resetSuccess();
    setLoading(true);
    console.log("Saving", type, address);
    const { street1, city, state, zip, unitNumber } = address;
    // track("DASHBOARD_SETTINGS_ADDRESS_CHANGE_SUBMITTED");
    const payload = {
      street: street1,
      city,
      state,
      zip,
      unit_number: unitNumber,
      normalized_street: street1,
      normalized_city: city,
      normalized_subdivision: state,
      normalized_postal_code: zip,
      normalized_country_code: "US"
    };

    if (window.location.pathname.includes("/dashboard/supportal/user")) {
      
      return supportalUpdateAddress({
      variables: {
        user_id: user.email,
        [`${type}_address`]: payload,
        ...(type !== "shipping" && sameAddress && { shipping_address: payload })
      },
      refetchQueries: [{ query: REFETCH_ADDRESSES }],
      awaitRefetchQueries: true
      // onCompleted: data => {}
    })
      .then(res => {
        console.log(res)
        if (type === "shipping") {
          setShippingValid(true);
        }
        if (type === "billing") {
          setBillingValid(true);
        }
        if (type !== "shipping" && sameAddress) {
          setShippingValid(true);
          setBillingValid(true);
        }
        console.log(res);
        console.log("COMPLETED");
        setLoading(false);
        if (!isMobile) {
          setSuccess();
        }
        // track("DASHBOARD_SETTINGS_ADDRESS_CHANGE_SUCCESS");
        return { success: true };
      })
      .catch(e => {
        if (type === "shipping") {
          setShippingValid(false);
        }
        if (type === "billing") {
          setBillingValid(false);
        }
        if (type !== "shipping" && sameAddress) {
          setShippingValid(false);
          setBillingValid(false);
        }
        console.log(e.message);
        setLoading(false);
        setErrorMessage("Invalid Address");
        if (!isMobile) setError("One or more of your addresses failed to save");
        // track("DASHBOARD_SETTINGS_ADDRESS_CHANGE_FAILURE", {
        //   message: "Invalid Address"
        // });
        return { success: false };
      });
    };
  };

  return (
    <div className="mt-4">
      {/* <Text className={isUpdated ? "" : "hidden"}>Update Successful</Text> */}
      <div>
        <Text weight="font-bold" className="mb-1">
          Billing address
        </Text>
        {renderBillingAddress()}
      </div>
      <div className="mt-5">
        <Text weight="font-bold" className="mb-1">
          Shipping address
        </Text>
        <input
          type="checkbox"
          name="shipSameAsBill"
          value="0"
          checked={sameAddress}
          onChange={toggleShipAddress}
          disabled={loading}
        />
        <Text className="ml-2 mb-1 inline-block">Same as billing</Text>
      </div>
      <div className={sameAddress ? "hidden" : ""}>
        {!sameAddress && renderShippingAddress()}
      </div>
      <Text className={errorMessage ? "" : "hidden"}>{errorMessage}</Text>
      <SettingsButton
        onClick={async () => setShouldValidate(true)}
        className={loading ? "disabled opacity-50 mt-5" : "mt-5"}
        disabled={loading}
      >
        Save address
      </SettingsButton>
    </div>
  );
};


const SUPPORTAL_UPDATE_ADDRESS = gql`
  mutation SupportalUpdateAddress(
    $billing_address: AddressInput
    $shipping_address: AddressInput
    $user_id: ID
  ) {
    updateAddress(
      user_id: $user_id
      billing_address: $billing_address
      shipping_address: $shipping_address
    ) {
      status
      code
      message
    }
  }
`;

const REFETCH_ADDRESSES = gql`
  query RefetchAddresses {
    user {
      billing_address {
        street
        city
        state
        zip
        country
      }
      shipping_address {
        street
        city
        state
        zip
        country
      }
    }
  }
`;

export default Address;
